import devicesRetina from 'marketing-website/media/images/pages/labs/devices@2x.jpg';
import styleguideRetina from 'marketing-website/media/images/pages/labs/styleguide@2x.jpg';
import styleguideSiteRetina from 'marketing-website/media/images/pages/labs/styleguide-site@2x.jpg';
import keynoteRetina from 'marketing-website/media/images/pages/labs/keynote@2x.jpg';
import sketchPaperRetina from 'marketing-website/media/images/pages/labs/sketch@2x.jpg';
import robotRetina from 'marketing-website/media/images/pages/labs/robot@2x.jpg';
import dashboardRetina from 'marketing-website/media/images/pages/labs/dashboard@2x.jpg';
import userflowsRetina from 'marketing-website/media/images/pages/labs/userflows@2x.jpg';

const assets = {
  devices: {
    alt: 'CSS Device: iPhone',
    src: devicesRetina,
    hasShadow: false,
    maxWidth: 387,
  },
  styleguide: {
    alt: 'How to maintain a Sketch styleguide',
    src: styleguideRetina,
    hasShadow: false,
    maxWidth: 387,
  },
  styleguideSite: {
    alt: 'Marvel CSS Styleguide',
    src: styleguideSiteRetina,
    hasShadow: false,
    maxWidth: 387,
  },
  keynote: {
    alt: 'Export Keynote files to Marvel',
    src: keynoteRetina,
    hasShadow: false,
    maxWidth: 387,
  },
  sketchPaper: {
    alt: 'iPhone 6 Printable Sketch Paper',
    src: sketchPaperRetina,
    hasShadow: false,
    maxWidth: 387,
  },
  botBot: {
    alt: 'BotBot: Server-Side Swift Slack Bot for Marvel',
    src: robotRetina,
    hasShadow: false,
    maxWidth: 387,
  },
  dashboard: {
    alt: 'Dashboard: Share what your team is working on',
    src: dashboardRetina,
    hasShadow: false,
    maxWidth: 387,
  },
  userflows: {
    alt: 'Userflow of a Marvel prototype',
    src: userflowsRetina,
    hasShadow: false,
    maxWidth: 387,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/labs/assets.js